import { render, staticRenderFns } from "./zhengju.vue?vue&type=template&id=b871f138&scoped=true&"
import script from "./zhengju.vue?vue&type=script&lang=js&"
export * from "./zhengju.vue?vue&type=script&lang=js&"
import style0 from "./zhengju.vue?vue&type=style&index=0&id=b871f138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b871f138",
  null
  
)

export default component.exports